import React, { FunctionComponent } from 'react';
import Table from '../../../../components/Table';
import { getColumns, getSearchString, headerBlock } from './utils';
import { connect } from 'react-redux';
import { IAppState } from '../../../../common/models/store/IAppState';
import NavigationFooter from '../../../../components/NavigationFooter';
import styles from './styles.module.scss';
import { IGlobalSearchFilter } from '../../../../common/models/filter/IGlobalSearchFilter';
import { Search } from '../../../../common/models/search/Search';
import { setReportCandidatesRoutine } from '../../../../containers/ShareReportModal/routines';
import { IBindingAction, IBindingCallback1 } from '../../../../common/models/callback';
import { history } from '../../../../common/helpers/history';
import { FormattedMessage } from 'react-intl';
import LinkButton from '../../../../components/LinkButton';
import Illustration from '../../../../components/Illustration';

interface IGlobalSearchDropDownProps {
  filter: IGlobalSearchFilter;
  items: Search[];
  total: number;
  loading: boolean;
  isRecentShows: boolean;
  showClearFilters: boolean;
  clearFilters: IBindingAction;
  setReportCandidates: IBindingCallback1<string[]>;
}

const GlobalSearchDropDown: FunctionComponent<IGlobalSearchDropDownProps> = ({
  filter,
  items,
  total,
  loading,
  isRecentShows,
  showClearFilters,
  clearFilters,
  setReportCandidates
}) => {
  const onRunReport = (id: string) => setReportCandidates([id]);
  const noDataPlaceholder = (
    <Illustration
      variant="binoculars"
      height="18rem"
      header={<FormattedMessage id="resultsNotFound" defaultMessage="Hmm... no matches found" />}
      description={showClearFilters ? (
        <FormattedMessage
          id="resultsNotFoundFilterHint"
          defaultMessage="Try adjusting your filters or searching for something else."
        />
      ) : (
        <FormattedMessage
          id="resultsNotFoundHint"
          defaultMessage="Try searching for something else"
        />
      )}
      button={showClearFilters ? (
        <LinkButton
          textIntlId="searchResult.clearFilters"
          defaultMessage="Clear filters"
          onClick={clearFilters}
        />
      ) : undefined}
    />
  );

  return (
    <div className={styles.content} onClick={event => event.stopPropagation()} role="presentation">
      {headerBlock(items.length, isRecentShows, clearFilters, items.length ? showClearFilters : false)}
      <Table
        className={`table-blue-focus ${styles.table}`}
        config={{
          data: { items, total },
          columns: getColumns(filter.input, onRunReport),
          rowIndent: 0,
          loading,
          hideHeader: true,
          focusable: true,
          defaultFocused: items[0],
          footer: <NavigationFooter showCursor showEnter />,
          onRowClicked: (row: Search) => history.push({ ...window.location, search: getSearchString(row) }),
          noDataPlaceholder
        }}
      />
    </div>
  );
};

const mapStateToProps = ({
  globalSearch: {
    items,
    recentIds,
    loading,
    total,
    isRecentShows
  }
}: IAppState) => ({ items, isRecentShows, loading, recentIds, total });

const mapDispachToProps = {
  setReportCandidates: setReportCandidatesRoutine
};

export default connect(mapStateToProps, mapDispachToProps)(GlobalSearchDropDown);
